import { render } from "./OperationView.vue?vue&type=template&id=620a40ae"
import script from "./OperationView.vue?vue&type=script&lang=js"
export * from "./OperationView.vue?vue&type=script&lang=js"

import "./OperationView.vue?vue&type=style&index=0&id=620a40ae&lang=css"

import exportComponent from "C:\\Users\\LCE\\Documents\\code\\front-end LCE\\centre-sante-gestion\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__